import React from 'react';
import { getAchievementRarity } from '../../config/badgeColors';
import './BadgeTooltip.scss';

const BadgeTooltip = ({ achievement }) => {
  if (!achievement) {
    return null;
  }

  const rarity = getAchievementRarity(achievement);
  const rarityDisplay = rarity.charAt(0).toUpperCase() + rarity.slice(1);

  return (
    <div className={`badge-tooltip badge-tooltip--${rarity}`}>
      <h4 className="badge-tooltip__title">{achievement.name}</h4>
      <p className="badge-tooltip__description">
        {achievement.description}
      </p>
      <div className="badge-tooltip__footer">
        <span className={`badge-tooltip__rarity badge-tooltip__rarity--${rarity}`}>
          {rarityDisplay}
        </span>
      </div>
    </div>
  );
};

export default BadgeTooltip;